// 固定资产管理（档案 / 变更 / 处置）路由
// Date 2026-09-07
//
// 命名约定：路径 /em/asset/<组件名首字母小写>，且 List / Task / Edit 结尾的路由
// 必须能被 emRouteHelperMixin 反解出实体名 emArchFixedAssetChange / emArchFixedAssetDisposal
// （它按结尾的 List / Task / Edit 截断），实体名同时是 vuex 模块名与 model 索引里的 key。
// 待办列表跳转审批页时用的是 name = <实体名>Task，所以 Task 路由的 name 不能乱起。

import emArchFixedAssetList from "@/views/em/asset/EmArchFixedAssetList.vue";
import emArchFixedAssetChangeEdit from "@/views/em/asset/EmArchFixedAssetChangeEdit.vue";
import emArchFixedAssetChangeList from "@/views/em/asset/EmArchFixedAssetChangeList.vue";
import emArchFixedAssetChangeTask from "@/views/em/asset/EmArchFixedAssetChangeTask.vue";
import emArchFixedAssetChangeQueryView from "@/views/em/asset/EmArchFixedAssetChangeQueryView.vue";
import emArchFixedAssetDisposalEdit from "@/views/em/asset/EmArchFixedAssetDisposalEdit.vue";
import emArchFixedAssetDisposalList from "@/views/em/asset/EmArchFixedAssetDisposalList.vue";
import emArchFixedAssetDisposalTask from "@/views/em/asset/EmArchFixedAssetDisposalTask.vue";
import emArchFixedAssetDisposalQueryView from "@/views/em/asset/EmArchFixedAssetDisposalQueryView.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
    {
        path: "/em/asset/emArchFixedAssetList",
        name: "emArchFixedAssetList",
        component: emArchFixedAssetList,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetChangeEdit",
        name: "emArchFixedAssetChangeEdit",
        component: emArchFixedAssetChangeEdit,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetChangeList",
        name: "emArchFixedAssetChangeList",
        component: emArchFixedAssetChangeList,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetChangeTask",
        name: "emArchFixedAssetChangeTask",
        component: emArchFixedAssetChangeTask,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetChangeQueryView",
        name: "emArchFixedAssetChangeQueryView",
        component: emArchFixedAssetChangeQueryView,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetDisposalEdit",
        name: "emArchFixedAssetDisposalEdit",
        component: emArchFixedAssetDisposalEdit,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetDisposalList",
        name: "emArchFixedAssetDisposalList",
        component: emArchFixedAssetDisposalList,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetDisposalTask",
        name: "emArchFixedAssetDisposalTask",
        component: emArchFixedAssetDisposalTask,
        meta: metaObject
    },
    {
        path: "/em/asset/emArchFixedAssetDisposalQueryView",
        name: "emArchFixedAssetDisposalQueryView",
        component: emArchFixedAssetDisposalQueryView,
        meta: metaObject
    },
]
